import { render, staticRenderFns } from "./ModalPropostas.vue?vue&type=template&id=1d518b1c&scoped=true&lang=pug"
import script from "./ModalPropostas.vue?vue&type=script&lang=js"
export * from "./ModalPropostas.vue?vue&type=script&lang=js"
import style0 from "./ModalPropostas.vue?vue&type=style&index=0&id=1d518b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d518b1c",
  null
  
)

export default component.exports